import "./our_team.css";
import { WrapperComponent, SectionTitle } from "../../../_imports";
import useScrollReveal from "../../../../hooks/utils/useScrollReveal";

import BryamImg from "../../../../assets/imgs/partners/bryam.webp";
import BatistaImg from "../../../../assets/imgs/partners/batista.webp";
import BernardiImg from "../../../../assets/imgs/partners/bernardi.webp";
import GustavoImg from "../../../../assets/imgs/partners/gustavo.webp";

// Partner data configuration
const partners = [
    {
        name: "Bryam Assolini",
        role: "Gerente Geral",
        img: BryamImg,
        width: 400,
        height: 413
    },
    {
        name: "Lucas Batista",
        role: "Líder Técnico",
        img: BatistaImg,
        width: 400,
        height: 408
    },
    {
        name: "Lucas Bernardi",
        role: "Executivo Comercial",
        img: BernardiImg,
        width: 400,
        height: 400
    },
    {
        name: "Gustavo Grosbelli",
        role: "Sucesso do Cliente",
        img: GustavoImg,
        width: 400,
        height: 404
    }
];

function OurTeam() {
    const { ref } = useScrollReveal({
        origin: "top",
        distance: "30px",
        duration: 800,
        delay: 200,
        reset: false
    });

    return (
        <section className="our-team-section" ref={ref}>
            <WrapperComponent>
                <div className="our-team-container">
                    <SectionTitle
                        text="CONHEÇA NOSSO TIME!"
                        color="orange"
                    />
                    <div className="team-grid">
                        {partners.map((partner, index) => (
                            <article key={index} className="team-card">
                                <div className="team-img-wrapper">
                                    <img
                                        src={partner.img}
                                        alt={`Foto de ${partner.name}`}
                                        width={partner.width}
                                        height={partner.height}
                                        loading="lazy"
                                    />
                                </div>
                                <div className="team-info">
                                    <h3>{partner.name}</h3>
                                    <p>{partner.role}</p>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </WrapperComponent>
        </section>
    );
}

export default OurTeam;
